import { useRef } from 'react'
import Styles from './SecretIdentityCard.module.scss'
import { ImageKey } from '../identities'
import { SecretIdentity } from 'components/SecretIdentity'
import { useButton } from '@react-aria/button'
import { usePreventScrollClick } from 'hooks/usePreventScrollClick'

type SecretIdentityCardProps = {
  imageKey: ImageKey
  isSelected?: boolean
  onSelect: (key: string) => void
}

export const SecretIdentityCard = ({ onSelect, imageKey, isSelected }: SecretIdentityCardProps) => {
  const ref = useRef(null)

  const { handleTouchStart, handleTouchMove, handleTouchEnd, isDragging } = usePreventScrollClick(10)

  const handleSelect = () => {
    if (!isDragging) {
      onSelect(imageKey)
    }
  }

  const { buttonProps } = useButton({ elementType: 'div', onPress: handleSelect }, ref)

  return (
    <SecretIdentity.Popout3D>
      <div
        className={Styles.card3d}
        ref={ref}
        {...buttonProps}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        data-testid="card-grid-item"
      >
        <SecretIdentity.CardBack imageKey={imageKey} isSelected={isSelected} />
      </div>
    </SecretIdentity.Popout3D>
  )
}
